import type { Translations } from "../types";

export const es: Translations = {
  nav: {
    about: "Nosotros",
    challenges: "Sus Desafíos",
    solutions: "Sus Soluciones",
    knowledge: "Centro de Conocimiento",
    execution: "Ejecución Inteligente",
    features: "Funcionalidades",
    modules: "Módulos",
    pricing: "Precios",
    docs: "Documentación",
    login: "Iniciar sesión",
    contact: "Contáctenos",
  },
  hero: {
    tagSecure: "Seguro",
    tagScalable: "Escalable",
    tagRealTime: "Tiempo Real",
    tagline: "Un único WMS para estandarizar operaciones en cada sitio.",
    titleTop: "NEXO",
    titleBottom: "Warehouse",
    subtitle:
      "Nuestro WMS orquesta personas, procesos, robótica y automatización en un sistema escalable.",
    ctaPrimary: "Hablar con un Experto",
    ctaSecondary: "Recursos Clave",
  },
  stats: {
    sectionTitle: "Convierte la Experiencia en Impacto Medible",
    customers: "6+",
    customersLabel: "Módulos Activos",
    customersDesc: "Bodegas, Productos, Inventario, Salidas, Ajustes y más.",
    expertise: "100%",
    expertiseLabel: "En la Nube",
    expertiseDesc: "Accede desde cualquier lugar. Sin instalaciones.",
    countries: "2",
    countriesLabel: "Idiomas",
    countriesDesc: "Soporte nativo completo en Español e Inglés.",
  },
  features: {
    badge: "Gestión de Almacén",
    title: "Control Total de Inventario en Tiempo Real",
    subtitle:
      "Nexo-Warehouse gestiona todo tu flujo de inventario — desde la recepción hasta el despacho — con trazabilidad completa y flujos de aprobación.",
    items: {
      inventory: {
        title: "Inventario en Tiempo Real",
        desc: "Rastrea cada producto en todas las ubicaciones con stock en vivo, Kardex y balance periódico.",
      },
      orders: {
        title: "Entradas y Salidas",
        desc: "Crea entradas y salidas con múltiples líneas, validación de stock y trazabilidad completa.",
      },
      analytics: {
        title: "Ajustes con Aprobación",
        desc: "Corrige inventario con justificación por línea. Envía, aprueba, rechaza o anula con control de roles.",
      },
      automation: {
        title: "Multi-bodega y Ubicaciones",
        desc: "Organiza por bodega, secciones, racks e islas de piso. Grid visual con colores de stock en tiempo real.",
      },
    },
  },
  cta: {
    title: "¿Listo para Transformar tu Almacén?",
    subtitle:
      "Únete a más de 1.600 empresas que confían en Nexo-Warehouse para gestionar sus operaciones.",
    primary: "Comenzar Gratis",
    secondary: "Agendar Demo",
  },
  login: {
    welcome: "Bienvenido de nuevo",
    subtitle: "Ingresa tus datos para continuar",
    emailLabel: "Usuario o correo",
    emailPlaceholder: "Ingresa tu usuario o correo",
    passwordLabel: "Contraseña",
    passwordPlaceholder: "Ingresa tu contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    submit: "Iniciar sesión",
    backHome: "← Volver al inicio",
    errorInvalid: "Credenciales inválidas. Intenta de nuevo.",
    errorNetwork: "Error de conexión. Verifica tu red.",
    errorSubscription: "Tu suscripción ha vencido.",
    subscriptionTitle: "Suscripción vencida",
    subscriptionMessage: "Tu suscripción a esta aplicación ha vencido. Para recuperar el acceso, realiza el pago de la suscripción desde la aplicación.",
    subscriptionBack: "Volver al login",
    subscriptionGoControl: "Ir al Panel de Control para pagar",
    subscriptionCopyLink: "Copiar enlace",
    subscriptionCopied: "Copiado",
    pastDueBanner: "Tu suscripción está en mora. Comunícate con el equipo interno para no perder el acceso.",
  },
  changePassword: {
    title: "Cambiar Contraseña",
    subtitle: "Debes cambiar tu contraseña antes de continuar.",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    mismatch: "Las contraseñas no coinciden",
    submit: "Cambiar contraseña",
    success: "Contraseña actualizada exitosamente",
  },
  forgotPassword: {
    title: "Recuperar Contraseña",
    subtitle: "Ingresa tu correo y te enviaremos un código de recuperación.",
    emailLabel: "Correo electrónico",
    emailPlaceholder: "Ingresa tu correo",
    sendCode: "Enviar Código",
    otpTitle: "Ingresa el Código",
    otpSubtitle: "Enviamos un código de 6 dígitos a tu correo.",
    otpPlaceholder: "000000",
    verify: "Verificar",
    otpError: "Código inválido o expirado. Intenta de nuevo.",
    otpExpired: "Código expirado.",
    resend: "Reenviar código",
    newPasswordTitle: "Nueva Contraseña",
    newPasswordSubtitle: "Ingresa tu nueva contraseña.",
    submit: "Restablecer Contraseña",
    successTitle: "Contraseña Restablecida",
    successSubtitle: "Tu contraseña fue cambiada exitosamente. Ya puedes iniciar sesión.",
    backToLogin: "Volver al login",
  },
  platform: {
    warehouses: "Bodegas",
    products: "Productos",
    inventory: "Inventario",
    stock: "Stock",
    kardex: "Kardex",
    receipts: "Entradas",
    dispatches: "Salidas",
    transfers: "Transferencias",
    balance: "Balance",
    adjustments: "Ajustes",
    analytics: "Analítica",
    dashboard: "Dashboard",
    reports: "Reportes",
    settings: "Configuración",
    typeUse: "Tipos de Uso",
    typeUnit: "Unidades de Medida",
    movementSubtype: "Movimientos",
    unitConversion: "Conversiones",
    category: "Categorías",
    admin: "Administración",
    users: "Usuarios",
    usage: "Uso",
    switchTo: "Cambiar a",
    logout: "Cerrar sesión",
    notifications: "Notificaciones",
    noNotifications: "No hay importaciones recientes",
    selectTimezone: "Seleccione la zona horaria",
  },
  users: {
    title: "Usuarios",
    subtitle: "Gestiona los usuarios que acceden a esta aplicación.",
    addUser: "Nuevo Usuario",
    editUser: "Editar Usuario",
    colName: "Nombre",
    colUsername: "Usuario",
    colEmail: "Correo",
    colRole: "Rol",
    colStatus: "Estado",
    colActions: "Acciones",
    nameLabel: "Nombre completo",
    namePlaceholder: "Juan Pérez",
    usernameLabel: "Usuario",
    usernamePlaceholder: "jperez",
    emailLabel: "Correo electrónico",
    emailPlaceholder: "juan@empresa.com",
    passwordLabel: "Contraseña",
    passwordPlaceholder: "Mínimo 8 caracteres",
    passwordOptional: "opcional",
    passwordNewPlaceholder: "Nueva contraseña (dejar vacío para mantener)",
    roleLabel: "Rol",
    rolePlaceholder: "Selecciona un rol...",
    save: "Guardar",
    cancel: "Cancelar",
    activate: "Activar",
    deactivate: "Desactivar",
    emptyTitle: "No hay usuarios",
    errorDuplicate: "El usuario o correo ya existe.",
    errorValidation: "Revisa los campos del formulario.",
    errorForbidden: "No tienes permiso para esta acción.",
    successCreated: "Usuario creado exitosamente.",
    successUpdated: "Usuario actualizado exitosamente.",
    successStatusChanged: "Estado del usuario actualizado.",
    pwMin8: "Mínimo 8 caracteres",
    pwLower: "Al menos una letra minúscula",
    pwUpper: "Al menos una letra mayúscula",
    pwNumber: "Al menos un número",
    pwSpecial: "Al menos un carácter especial",
  },
  typeUse: {
    title: "Tipo de Uso",
    subtitle: "Gestiona los tipos de uso de bodega. Requerido antes de crear bodegas.",
    addTypeUse: "Agregar Tipo de Uso",
    editTypeUse: "Editar Tipo de Uso",
    deleteTypeUse: "Eliminar Tipo de Uso",
    nameLabel: "Nombre",
    namePlaceholder: "Ingresa el nombre del tipo de uso...",
    save: "Guardar",
    cancel: "Cancelar",
    confirmDelete: "Eliminar Tipo de Uso",
    confirmDeleteDesc: "¿Estás seguro de eliminar este tipo de uso? Esta acción no se puede deshacer.",
    confirmDeleteBtn: "Eliminar",
    emptyTitle: "No hay tipos de uso",
    emptySubtitle: "Crea tu primer tipo de uso para comenzar a configurar bodegas.",
    createdAt: "Creado",
    errorMinLength: "El nombre debe tener al menos 3 caracteres.",
    errorDuplicate: "Ya existe un tipo de uso con este nombre.",
    errorNotFound: "Tipo de uso no encontrado.",
    errorForbidden: "No tienes permiso para esta acción.",
    successCreated: "Tipo de uso creado exitosamente.",
    successUpdated: "Tipo de uso actualizado exitosamente.",
    successDeleted: "Tipo de uso eliminado exitosamente.",
  },
  typeUnit: {
    title: "Unidades de Medida",
    subtitle: "Gestiona las unidades de medida para tu inventario.",
    addTypeUnit: "Crear Unidad",
    searchPlaceholder: "Buscar por código o nombre...",
    filterAll: "Todas",
    filterActive: "Activas",
    filterInactive: "Inactivas",
    colCode: "Código",
    colName: "Nombre",
    colAbbreviation: "Abreviatura",
    colStatus: "Estado",
    colActions: "Acciones",
    codeLabel: "Código",
    codePlaceholder: "ej. KG, UD, LT",
    nameLabel: "Nombre",
    namePlaceholder: "ej. Kilogramo, Unidad, Litro",
    abbreviationLabel: "Abreviatura",
    abbreviationPlaceholder: "ej. kg, ud, lt",
    save: "Guardar",
    cancel: "Cancelar",
    activate: "Activar",
    deactivate: "Desactivar",
    statusActive: "Activa",
    statusInactive: "Inactiva",
    emptyTitle: "No hay unidades de medida",
    emptySubtitle: "Crea tu primera unidad para comenzar a gestionar inventario.",
    errorValidation: "Completa todos los campos correctamente.",
    errorDuplicateCode: "Ya existe una unidad con este código.",
    errorDuplicateAbbr: "Ya existe una unidad con esta abreviatura.",
    errorForbidden: "No tienes permiso para esta acción.",
    successCreated: "Unidad creada exitosamente.",
    successStatusChanged: "Estado de la unidad actualizado.",
  },
  warehouses: {
    title: "Bodegas",
    subtitle: "Gestiona todas tus ubicaciones de almacén.",
    addWarehouse: "Agregar Bodega",
    editWarehouse: "Editar Bodega",
    searchPlaceholder: "Buscar por nombre o código...",
    filterAll: "Todas",
    filterActive: "Activas",
    filterInactive: "Inactivas",
    colName: "Nombre",
    colCode: "Código",
    colDescription: "Descripción",
    colTypeUse: "Tipo de Uso",
    colStatus: "Estado",
    colActions: "Acciones",
    statusActive: "Activa",
    statusInactive: "Inactiva",
    nameLabel: "Nombre",
    namePlaceholder: "Ingresa el nombre de la bodega...",
    codeLabel: "Código",
    codePlaceholder: "ej. BOD-001",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Ingresa una descripción...",
    typeUseLabel: "Tipo de Uso",
    typeUsePlaceholder: "Selecciona un tipo de uso...",
    save: "Guardar",
    cancel: "Cancelar",
    activate: "Activar",
    deactivate: "Desactivar",
    emptyTitle: "No hay bodegas",
    emptySubtitle: "Crea tu primera bodega para comenzar.",
    emptyNoTypeUseTitle: "No hay tipos de uso configurados",
    emptyNoTypeUseSubtitle: "Necesitas crear al menos un tipo de uso antes de agregar bodegas.",
    emptyNoTypeUseAction: "Ir a Tipos de Uso",
    errorDuplicateCode: "Ya existe una bodega con este código.",
    errorValidation: "Completa todos los campos requeridos (mín 3 caracteres).",
    errorNotFound: "Bodega no encontrada.",
    errorForbidden: "No tienes permiso para esta acción.",
    successCreated: "Bodega creada exitosamente.",
    successUpdated: "Bodega actualizada exitosamente.",
    successStatusChanged: "Estado de la bodega actualizado.",
  },
  isle: {
    sectionOverview: "Vista de Secciones",
    addSection: "Agregar Sección",
    rackType: "Rack",
    floorIslandType: "Isla de Piso",
    nameLabel: "Nombre",
    namePlaceholder: "ej. Rack A1, Zona Piso B",
    typeLabel: "Tipo",
    levelsLabel: "Niveles",
    columnsLabel: "Columnas",
    depthLabel: "Profundidad",
    capacityLabel: "Capacidad",
    unitLabel: "Unidad de Medida",
    unitPlaceholder: "Selecciona una unidad...",
    save: "Guardar",
    cancel: "Cancelar",
    activate: "Activar",
    deactivate: "Desactivar",
    statusActive: "Activa",
    statusInactive: "Inactiva",
    emptyTitle: "No hay secciones",
    emptySubtitle: "Agrega tu primera sección para organizar esta bodega.",
    errorDuplicateName: "Ya existe una sección con este nombre en esta bodega.",
    errorValidation: "Completa todos los campos requeridos correctamente.",
    errorForbidden: "No tienes permiso para esta acción.",
    successCreated: "Sección creada exitosamente.",
    successStatusChanged: "Estado de la sección actualizado.",
    cellsLabel: "celdas",
    capacityUsed: "capacidad",
  },
  location: {
    statusActive: "Activa",
    statusInactive: "Bloqueada",
    toggleConfirm: "Clic para cambiar estado",
    errorNotFound: "Ubicación no encontrada.",
    errorHasInventory: "No se puede cambiar — la ubicación tiene inventario activo.",
    errorForbidden: "No tienes permiso para esta acción.",
    successStatusChanged: "Estado de ubicación actualizado.",
    activeLabel: "Disponible",
    inactiveLabel: "Bloqueada",
    partialLabel: "Parcial",
    levelLabel: "Nivel",
    positionLabel: "Pos",
    capacityPerLayer: "Por capa",
    layers: "Niveles",
    availableLabel: "Disponible",
    onHand: "En mano",
    reserved: "Reservado",
    available: "Disponible",
    lastMovement: "Último",
    inactivate: "Desactivar",
    activate: "Activar",
    depthLabel: "Nivel",
    depthEmpty: "Vacía",
    depthFull: "Llena",
    depthBlocked: "Bloqueada",
    depthPartial: "Parcial",
    noInventoryLayers: "Sin inventario — toca una capa para ver detalles",
    stockLabel: "Inventario",
    selectLotHint: "Múltiples lotes disponibles — selecciona uno",
    noLotOption: "Sin lote",
    remainingOf: "Restante: {remaining} de {total}",
    stockAfter: "Stock actual: {current} → {after}",
    originRemaining: "Origen: {remaining} restante de {total}",
  },
  conversion: {
    result: "{quantity} {fromUnit} × {factor} = {result} {toUnit}",
    factor: "factor: {factor}",
    noConversion: "No existe conversión de {fromUnit} a {toUnit}. Créela en Configuración > Conversiones de Unidad.",
    loading: "Verificando conversión...",
  },
  movementSubtype: {
    title: "Subtipos de Movimiento",
    subtitle: "Configura subtipos operativos para transacciones de inventario.",
    addSubtype: "Crear Subtipo",
    editSubtype: "Editar Subtipo",
    colCode: "Código",
    colName: "Nombre",
    colType: "Tipo",
    colRequiresRef: "Req. Referencia",
    colStatus: "Estado",
    colActions: "Acciones",
    typeLabel: "Tipo",
    typePlaceholder: "Selecciona tipo...",
    codeLabel: "Código",
    codePlaceholder: "ej. COMPRA, VENTA",
    nameLabel: "Nombre",
    namePlaceholder: "ej. Compra a proveedor",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Descripción opcional...",
    requiresRefLabel: "¿Requiere referencia?",
    save: "Guardar",
    cancel: "Cancelar",
    activate: "Activar",
    deactivate: "Desactivar",
    statusActive: "Activo",
    statusInactive: "Inactivo",
    refYes: "Sí",
    refNo: "No",
    typeIn: "Entrada",
    typeOut: "Salida",
    emptyTitle: "No hay subtipos",
    emptySubtitle: "Crea tu primer subtipo de movimiento.",
    errorDuplicateCode: "Ya existe un subtipo con este código.",
    errorTypeInactive: "El tipo de movimiento seleccionado está inactivo. Contacta al administrador.",
    errorValidation: "Completa todos los campos requeridos correctamente.",
    errorForbidden: "No tienes permiso para esta acción.",
    successCreated: "Subtipo creado exitosamente.",
    successUpdated: "Subtipo actualizado exitosamente.",
    successStatusChanged: "Estado del subtipo actualizado.",
  },
  unitConversion: {
    title: "Conversiones de Unidad",
    subtitle: "Gestiona factores de conversión entre unidades.",
    addConversion: "Crear Conversión",
    editConversion: "Editar Conversión",
    colFromUnit: "Unidad Base",
    colToUnit: "Unidad Embalaje",
    colProduct: "Producto",
    colFactor: "Factor",
    colStatus: "Estado",
    colActions: "Acciones",
    fromUnitLabel: "Unidad base (origen)",
    toUnitLabel: "Unidad embalaje (destino)",
    productLabel: "Producto",
    productPlaceholder: "Global (todos los productos)",
    factorLabel: "Factor",
    factorPlaceholder: "ej. 24",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "ej. 1 caja = 24 unidades",
    unitPlaceholder: "Selecciona unidad...",
    globalLabel: "— (Global)",
    save: "Guardar",
    cancel: "Cancelar",
    activate: "Activar",
    deactivate: "Desactivar",
    statusActive: "Activa",
    statusInactive: "Inactiva",
    emptyTitle: "No hay conversiones",
    emptySubtitle: "Crea tu primera conversión de unidad.",
    errorSameUnit: "La unidad origen y destino no pueden ser la misma.",
    errorInvalidFactor: "El factor debe ser un número positivo mayor a cero.",
    errorDuplicate: "Ya existe una conversión activa para este par de unidades.",
    errorValidation: "Completa todos los campos requeridos correctamente.",
    errorForbidden: "No tienes permiso para esta acción.",
    successCreated: "Conversión creada exitosamente.",
    successUpdated: "Conversión actualizada exitosamente.",
    successStatusChanged: "Estado de la conversión actualizado.",
  },
  category: {
    title: "Categorías",
    subtitle: "Gestiona las categorías de productos.",
    addCategory: "Crear Categoría",
    editCategory: "Editar Categoría",
    searchPlaceholder: "Buscar por código o nombre...",
    filterAll: "Todas",
    filterActive: "Activas",
    filterInactive: "Inactivas",
    colCode: "Código",
    colName: "Nombre",
    colDescription: "Descripción",
    colStatus: "Estado",
    colActions: "Acciones",
    codeLabel: "Código",
    codePlaceholder: "ej. ELEC",
    nameLabel: "Nombre",
    namePlaceholder: "ej. Electrónicos",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Descripción opcional...",
    save: "Guardar",
    cancel: "Cancelar",
    activate: "Activar",
    deactivate: "Desactivar",
    statusActive: "Activa",
    statusInactive: "Inactiva",
    systemBadge: "Sistema",
    emptyTitle: "No hay categorías",
    emptySubtitle: "Crea tu primera categoría para clasificar productos.",
    errorDuplicateCode: "Ya existe una categoría con este código.",
    errorValidation: "Completa todos los campos requeridos correctamente.",
    errorFieldRequired: "Este campo es obligatorio.",
    errorForbidden: "No tienes permiso para esta acción.",
    errorSystem: "Las categorías del sistema no se pueden modificar.",
    successCreated: "Categoría creada exitosamente.",
    successUpdated: "Categoría actualizada exitosamente.",
    successStatusChanged: "Estado de la categoría actualizado.",
  },
  inventory: {
    title: "Inventario",
    subtitle: "Niveles de stock en todas las ubicaciones.",
    searchPlaceholder: "Buscar por producto...",
    colProduct: "Producto",
    colOnHand: "En Mano",
    colReserved: "Reservado",
    colAvailable: "Disponible",
    colUnit: "Unidad",
    colLot: "Lote",
    colLastMovement: "Último Movimiento",
    emptyTitle: "No hay datos de inventario.",
  },
  balance: {
    title: "Balance de Inventario",
    subtitle: "Balance por período, producto y ubicación.",
    closePeriod: "Cerrar Período",
    closeConfirmTitle: "Cerrar Período",
    closeConfirmDesc: "¿Estás seguro de cerrar este período? Se calcularán los saldos finales y se creará el período siguiente. Esta acción no se puede deshacer.",
    closeConfirmBtn: "Cerrar Período",
    cancel: "Cancelar",
    year: "Año",
    month: "Mes",
    colProduct: "Producto",
    colLocation: "Ubicación",
    colOpening: "Saldo Ini.",
    colInflows: "Entradas",
    colOutflows: "Salidas",
    colClosing: "Saldo Act.",
    colStatus: "Estado",
    statusOpen: "Abierto",
    statusClosed: "Cerrado",
    emptyTitle: "No hay registros de balance para este período.",
    successClosed: "Período cerrado exitosamente.",
    errorAlreadyClosed: "Este período ya está cerrado.",
    errorPendingMovements: "No se puede cerrar: hay movimientos pendientes.",
    errorNotFound: "No se encontraron registros para este período.",
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
  },
  kardex: {
    title: "Kardex",
    subtitle: "Historial de movimientos de inventario.",
    colDate: "Fecha",
    colProduct: "Producto",
    colLocation: "Ubicación",
    colType: "Tipo",
    colQuantity: "Cantidad",
    colUnit: "Unidad",
    colFactor: "Factor",
    colQuantityBase: "Cant. Base",
    colBalance: "Saldo Después",
    colSource: "Origen",
    colReference: "Referencia",
    colWarehouse: "Bodega",
    filterWarehouse: "Bodega",
    filterProduct: "Producto",
    filterFrom: "Desde",
    filterTo: "Hasta",
    emptyTitle: "No se encontraron movimientos.",
    sourceReceipt: "Entrada",
    sourceDispatch: "Salida",
    sourceAdjustment: "Ajuste",
    sourceTransfer: "Transferencia",
    columns: "Columnas",
  },
  adjustments: {
    title: "Ajustes de Inventario",
    subtitle: "Gestiona correcciones y ajustes de inventario.",
    newAdjustment: "Nuevo Ajuste",
    colNumber: "N° Ajuste",
    colType: "Tipo",
    colWarehouse: "Bodega",
    colDate: "Fecha",
    colCreator: "Creador",
    colStatus: "Estado",
    statusDraft: "Borrador",
    statusPending: "En Aprobación",
    statusApproved: "Aprobado",
    statusRejected: "Rechazado",
    statusVoided: "Anulado",
    filterAll: "Todos",
    emptyList: "No hay ajustes.",
    reasonLabel: "Motivo",
    reasonPlaceholder: "Motivo del ajuste...",
    referenceLabel: "Referencia",
    referencePlaceholder: "Documento soporte...",
    notesLabel: "Observaciones",
    notesPlaceholder: "Observaciones opcionales...",
    subtypeLabel: "Tipo de Ajuste",
    warehouseLabel: "Bodega",
    selectSubtype: "Selecciona tipo...",
    selectWarehouse: "Selecciona bodega...",
    createDraft: "Crear Borrador",
    lines: "Renglones",
    emptyLines: "No hay renglones. Agrega el primero.",
    addLine: "Agregar Renglón",
    justificationLabel: "Justificación",
    justificationPlaceholder: "Motivo de este renglón...",
    quantityLabel: "Cantidad (+/-)",
    unitLabel: "Unidad",
    stepProduct: "Producto",
    stepLocation: "Ubicación",
    stepDetails: "Detalles",
    searchProduct: "Buscar producto...",
    searchLocation: "Buscar ubicación...",
    next: "Siguiente →",
    back: "← Atrás",
    add: "Agregar",
    addAndContinue: "Agregar y Seguir",
    done: "Listo",
    linesAdded: "líneas agregadas",
    saving: "Guardando...",
    cancel: "Cancelar",
    submit: "Enviar a Aprobación",
    submitTitle: "Enviar a Aprobación",
    submitDesc: "Los renglones serán validados antes del envío. Una vez enviado, no podrá editarse hasta que sea aprobado o rechazado.",
    approve: "Aprobar",
    approveTitle: "Aprobar Ajuste",
    approveDesc: "Esto impactará el inventario de forma inmediata.",
    approveComment: "Comentario (opcional)",
    reject: "Rechazar",
    rejectTitle: "Rechazar Ajuste",
    rejectDesc: "El creador podrá corregir y reenviar.",
    rejectReason: "Motivo de rechazo",
    rejectPlaceholder: "Motivo del rechazo...",
    voidAction: "Anular",
    voidTitle: "Anular Ajuste",
    voidDesc: "Esto revertirá el impacto en el inventario.",
    voidReason: "Motivo de anulación",
    voidPlaceholder: "Motivo de la anulación...",
    stockAvailable: "Disponible",
    stockWarning: "Esto dejará el stock por debajo de cero",
    cannotApproveSelf: "No puedes aprobar un ajuste que tú creaste.",
    successCreated: "Ajuste creado.",
    successSubmitted: "Ajuste enviado a aprobación.",
    errorReferenceRequired: "El documento de referencia es requerido para enviar a aprobación.",
    successApproved: "Ajuste aprobado.",
    successRejected: "Ajuste rechazado.",
    successVoided: "Ajuste anulado.",
    successLineAdded: "Renglón agregado.",
    successLineUpdated: "Renglón actualizado.",
    successLineRemoved: "Renglón eliminado.",
    editLine: "Editar Renglón",
    saveChanges: "Guardar Cambios",
  },
  receipts: {
    title: "Entradas",
    newReceipt: "Nueva Entrada",
    addLine: "Agregar Línea",
    confirmReceipt: "Confirmar Entrada",
    cancelReceipt: "Anular Entrada",
    cancelReason: "Motivo de Anulación",
    cancelReasonPlaceholder: "Motivo de la anulación...",
    cancelWarning: "Esto revertirá todos los movimientos de stock. Indica un motivo.",
    reference: "Referencia",
    referencePlaceholder: "Número de factura...",
    notes: "Observaciones",
    notesPlaceholder: "Observaciones opcionales...",
    createDraft: "Crear Borrador",
    subtypeLabel: "Subtipo",
    warehouseLabel: "Bodega",
    selectSubtype: "Selecciona subtipo...",
    selectWarehouse: "Selecciona bodega...",
    colReceiptNum: "N° Entrada",
    colSubtype: "Subtipo",
    colWarehouse: "Bodega",
    colDate: "Fecha",
    colStatus: "Estado",
    statusDraft: "Borrador",
    statusConfirmed: "Confirmada",
    statusCancelled: "Anulada",
    lines: "Líneas",
    emptyLines: "No hay líneas. Agrega tu primera línea.",
    emptyList: "No hay entradas.",
    filterAll: "Todas",
    stepProduct: "Producto",
    stepLocation: "Ubicación",
    stepQuantity: "Cantidad — Unidad",
    unitLabel: "Unidad",
    quantityLabel: "Cantidad",
    lotLabel: "Lote",
    searchProduct: "Buscar producto...",
    searchLocation: "Buscar ubicación...",
    capacityLabel: "Capacidad",
    capacityWarning: "La cantidad excede la capacidad de la ubicación",
    next: "Siguiente →",
    back: "← Atrás",
    add: "Agregar",
    addAndContinue: "Agregar y Seguir",
    done: "Listo",
    linesAdded: "líneas agregadas",
    saving: "Guardando...",
    cancel: "Cancelar",
    successCreated: "Entrada creada.",
    successConfirmed: "Entrada confirmada.",
    successCancelled: "Entrada anulada.",
    successLineAdded: "Línea agregada.",
    successLineUpdated: "Línea actualizada.",
    successLineRemoved: "Línea eliminada.",
    editLine: "Editar Línea",
    saveChanges: "Guardar Cambios",
  },
  dispatches: {
    title: "Salidas",
    newDispatch: "Nueva Salida",
    addLine: "Agregar Línea",
    confirmDispatch: "Confirmar Salida",
    cancelDispatch: "Anular Salida",
    cancelReason: "Motivo de Anulación",
    cancelReasonPlaceholder: "Motivo de la anulación...",
    cancelWarning: "Esto devolverá todo el stock a las ubicaciones originales. Indica un motivo.",
    reference: "Referencia",
    referencePlaceholder: "Número de pedido...",
    destination: "Destino",
    destinationPlaceholder: "Cliente o destino...",
    notes: "Observaciones",
    notesPlaceholder: "Observaciones opcionales...",
    createDraft: "Crear Borrador",
    subtypeLabel: "Subtipo",
    warehouseLabel: "Bodega",
    selectSubtype: "Selecciona subtipo...",
    selectWarehouse: "Selecciona bodega...",
    colDispatchNum: "N° Salida",
    colSubtype: "Subtipo",
    colWarehouse: "Bodega",
    colDestination: "Destino",
    colDate: "Fecha",
    colStatus: "Estado",
    statusDraft: "Borrador",
    statusConfirmed: "Confirmada",
    statusCancelled: "Anulada",
    lines: "Líneas",
    emptyLines: "No hay líneas. Agrega tu primera línea.",
    emptyList: "No hay salidas.",
    filterAll: "Todas",
    stepProduct: "Producto",
    stepLocation: "Ubicación",
    stepQuantity: "Cantidad — Unidad",
    unitLabel: "Unidad",
    quantityLabel: "Cantidad",
    lotLabel: "Lote",
    searchProduct: "Buscar producto...",
    searchLocation: "Buscar ubicación...",
    availableStock: "Disponible",
    stockWarning: "La cantidad excede el stock disponible",
    insufficientStock: "Stock insuficiente para confirmar la salida.",
    next: "Siguiente →",
    back: "← Atrás",
    add: "Agregar",
    addAndContinue: "Agregar y Seguir",
    done: "Listo",
    linesAdded: "líneas agregadas",
    saving: "Guardando...",
    cancel: "Cancelar",
    successCreated: "Salida creada.",
    successConfirmed: "Salida confirmada.",
    successCancelled: "Salida anulada.",
    successLineAdded: "Línea agregada.",
    successLineUpdated: "Línea actualizada.",
    successLineRemoved: "Línea eliminada.",
    editLine: "Editar Línea",
    saveChanges: "Guardar Cambios",
  },
  transfers: {
    title: "Transferencias",
    newTransfer: "Nueva Transferencia",
    colNumber: "N° Trans.",
    colFrom: "Bodega Origen",
    colTo: "Bodega Destino",
    colDate: "Fecha",
    colStatus: "Estado",
    statusDraft: "Borrador",
    statusConfirmed: "Confirmada",
    statusCancelled: "Anulada",
    filterAll: "Todas",
    emptyList: "No hay transferencias.",
    warehouseFrom: "Bodega Origen",
    warehouseTo: "Bodega Destino",
    selectWarehouse: "Selecciona bodega...",
    reasonLabel: "Motivo",
    reasonPlaceholder: "Motivo de la transferencia...",
    notesLabel: "Observaciones",
    notesPlaceholder: "Observaciones opcionales...",
    createDraft: "Crear Borrador",
    cancel: "Cancelar",
    lines: "Líneas",
    emptyLines: "No hay líneas. Agrega la primera.",
    addLine: "Agregar Línea",
    confirmTransfer: "Confirmar Transferencia",
    cancelTransfer: "Anular Transferencia",
    cancelReason: "Motivo de Anulación",
    cancelReasonPlaceholder: "Motivo de la anulación...",
    cancelWarning: "Esto revertirá los movimientos de stock en ambas bodegas.",
    stepProduct: "Producto",
    stepLocationFrom: "Ubicación Origen",
    stepLocationTo: "Ubicación Destino",
    stepQuantity: "Cantidad",
    searchProduct: "Buscar producto...",
    searchLocation: "Buscar ubicación...",
    unitLabel: "Unidad",
    quantityLabel: "Cantidad",
    lotLabel: "Lote",
    availableStock: "Disponible",
    stockWarning: "La cantidad excede el stock disponible",
    next: "Siguiente →",
    back: "← Atrás",
    add: "Agregar",
    addAndContinue: "Agregar y Seguir",
    done: "Listo",
    linesAdded: "líneas agregadas",
    saving: "Guardando...",
    editLine: "Editar Línea",
    saveChanges: "Guardar Cambios",
    successCreated: "Transferencia creada.",
    successConfirmed: "Transferencia confirmada.",
    successCancelled: "Transferencia anulada.",
    successLineAdded: "Línea agregada.",
    successLineUpdated: "Línea actualizada.",
    successLineRemoved: "Línea eliminada.",
  },
  products: {
    title: "Productos",
    subtitle: "Gestiona tu catálogo de productos.",
    addProduct: "Agregar Producto",
    importProducts: "Importar",
    editProduct: "Editar Producto",
    searchPlaceholder: "Buscar por código o nombre...",
    filterAll: "Todos",
    filterActive: "Activos",
    filterInactive: "Inactivos",
    filterAllCategories: "Todas las categorías",
    colCode: "Código",
    colName: "Nombre",
    colUnit: "Unidad",
    colCategory: "Categoría",
    colStatus: "Estado",
    colActions: "Acciones",
    codeLabel: "Código",
    codePlaceholder: "ej. PROD-001",
    nameLabel: "Nombre",
    namePlaceholder: "ej. Laptop HP ProBook",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Descripción opcional...",
    unitLabel: "Unidad Base",
    unitPlaceholder: "Selecciona una unidad...",
    categoryLabel: "Categoría",
    categoryPlaceholder: "Sin categoría",
    save: "Guardar",
    cancel: "Cancelar",
    activate: "Activar",
    deactivate: "Desactivar",
    statusActive: "Activo",
    statusInactive: "Inactivo",
    emptyTitle: "No hay productos",
    emptySubtitle: "Crea tu primer producto o importa desde CSV.",
    errorDuplicateCode: "Ya existe un producto con este código.",
    errorValidation: "Completa todos los campos requeridos correctamente.",
    errorFieldRequired: "Este campo es obligatorio.",
    errorForbidden: "No tienes permiso para esta acción.",
    successCreated: "Producto creado exitosamente.",
    successUpdated: "Producto actualizado exitosamente.",
    successStatusChanged: "Estado del producto actualizado.",
    importTitle: "Importar Productos",
    importDescription: "Sube un archivo CSV con columnas: code, name, description, typeUnitId",
    importSelectFile: "Seleccionar archivo...",
    importMaxItems: "Máximo 1.000 productos por carga.",
    importBtn: "Importar",
    importResultCreated: "Creados",
    importResultSkipped: "Omitidos",
    importResultErrors: "Errores",
    importParsing: "Procesando archivo...",
    importUploading: "Subiendo...",
    importErrorServer: "Error del servidor al procesar el archivo. Verifica el formato e intenta de nuevo.",
    importErrorFormat: "Solo se aceptan archivos CSV.",
    importErrorSize: "El archivo pesa {size} MB. El máximo permitido es 10 MB. Por favor comunícate con soporte.",
  },
  erpDocuments: {
    title: "Gestión de Documentos ERP — Siigo",
    btnLabel: "Siigo",
    selected: "Seleccionados",
    statusPending: "Pendiente",
    statusValid: "Válido",
    statusError: "Error",
    searchPlaceholder: "Buscar por # documento o cliente...",
    colDocument: "# Documento",
    colDate: "Fecha",
    colCustomer: "Cliente",
    colAmount: "Monto",
    colStatus: "Novedad",
    colProduct: "Producto",
    colQuantity: "Cantidad",
    colLocation: "Ubicación",
    cancel: "Cancelar",
    validate: "Validar Inventario",
    execute: "Ejecutar Importación",
    reject: "Rechazar",
    reportTitle: "Reporte de Ubicaciones",
    close: "Cerrar",
    download: "Descargar",
    empty: "No hay documentos pendientes",
    errorExecute: "Error al ejecutar la importación.",
    msgDocNotFound: "Documento no encontrado",
    msgNoWarehouse: "Sin bodega asignada",
    msgStockOk: "Stock disponible",
    msgPurchaseOk: "Compra — sin validación de stock requerida",
    msgInsufficientStock: "Stock insuficiente para {product} (disponible: {available}, requerido: {required})",
    errNoLocation: "La bodega no tiene ubicaciones activas. Cree una sección antes de ejecutar.",
    errProductNotFound: "Producto no encontrado: {code}",
    errInsufficientStockExec: "Stock insuficiente para {product} durante la ejecución.",
  },
  contact: {
    title: "Contáctanos",
    subtitle: "Nos encantaría saber de ti. Completa el formulario a continuación.",
    nameLabel: "Nombre",
    namePlaceholder: "Ingresa tu nombre",
    emailLabel: "Correo",
    emailPlaceholder: "Ingresa tu correo",
    messageLabel: "Mensaje",
    messagePlaceholder: "Escribe tu consulta",
    submit: "Enviar Mensaje",
    successMessage: "Mensaje enviado. Te contactaremos pronto.",
  },
  modules: {
    title: "Módulos",
    subtitle: "Todo lo que necesitas para gestionar tus operaciones de almacén.",
    warehouses: "Bodegas",
    warehousesDesc: "Múltiples bodegas con secciones, racks e islas de piso.",
    products: "Productos",
    productsDesc: "Catálogo completo con importación masiva CSV.",
    inventory: "Inventario",
    inventoryDesc: "Stock, Kardex, Balance, Entradas, Salidas, Ajustes.",
    settings: "Configuración",
    settingsDesc: "Unidades, Conversiones, Subtipos de movimiento.",
    multiTenant: "Multi-empresa",
    multiTenantDesc: "Cada empresa con datos aislados.",
    bilingual: "Bilingüe",
    bilingualDesc: "Soporte nativo en Español e Inglés.",
  },
  pricing: {
    title: "Precios",
    subtitle: "Contáctanos para una cotización personalizada.",
    cta: "Solicitar Cotización",
  },
  analytics: {
    title: "Dashboard",
    subtitle: "Resumen analítico de inventario.",
    movementsTitle: "Movimientos por Día",
    inflows: "Entradas",
    outflows: "Salidas",
    topProductsTitle: "Top 10 Productos",
    occupancyTitle: "Ocupación por Bodega",
    stockTitle: "Stock por Bodega",
    totalUnits: "Unidades Totales",
    totalProducts: "Productos",
    noData: "No hay datos para este período.",
    from: "Desde",
    to: "Hasta",
    reportsTitle: "Reportes",
    reportsSubtitle: "Genera, revisa y exporta reportes detallados.",
  },
  reports: {
    quickGenerate: "Generación Rápida",
    kardexTitle: "Kardex",
    kardexDesc: "Historial de movimientos por producto y bodega",
    stockTitle: "Stock",
    stockDesc: "Niveles actuales de inventario por producto",
    balanceTitle: "Balance",
    balanceDesc: "Balance periódico por producto y ubicación",
    generate: "Generar",
    totalGenerated: "Total Reportes",
    totalGeneratedDesc: "Generados este período",
    lastGenerated: "Último Generado",
    lastGeneratedDesc: "Reporte más reciente",
    generatedReports: "Reportes Generados",
    colName: "Nombre del Reporte",
    colType: "Tipo",
    colDateRange: "Rango de Fechas",
    colFormat: "Formato",
    colGeneratedOn: "Generado",
    colStatus: "Estado",
    colAction: "Acción",
    statusReady: "Listo",
    statusGenerating: "Generando",
    statusFailed: "Fallido",
    download: "Descargar",
    noReports: "No hay reportes generados aún.",
    filterPlaceholder: "Buscar aquí...",
    export: "Exportar",
    filter: "Filtrar",
    warehouseLabel: "Bodega",
    warehousePlaceholder: "Selecciona bodega...",
    productLabel: "Producto",
    productPlaceholder: "Todos los productos",
    fromLabel: "Desde",
    toLabel: "Hasta",
    formatLabel: "Formato",
    cancel: "Cancelar",
    allWarehouses: "Todas las bodegas",
    allProducts: "Todos los productos",
    thisMonth: "Este mes",
    preset15Days: "15 días",
    preset1Month: "1 mes",
    preset2Months: "2 meses",
    preset3Months: "3 meses",
    preset5Months: "5 meses",
    preset6Months: "6 meses",
    preset1Year: "1 año",
    expired: "Reporte expirado",
  },
  planLimit: {
    title: "Límite del plan alcanzado",
    close: "Cerrar",
    viewPlan: "Comunícate con soporte para ampliar tu plan.",
    pageTitle: "Uso del Plan",
    pageSubtitle: "Uso actual de recursos frente a los límites de tu suscripción.",
    warehouses: "Bodegas",
    products: "Productos",
    users: "Usuarios",
    sections: "Secciones por Bodega",
    unlimited: "Ilimitado",
    loading: "Cargando uso del plan...",
    errorLoading: "No se pudo cargar el uso del plan. Intenta de nuevo más tarde.",
    featuresTitle: "Características del Plan",
    bulkImport: "Importación Masiva",
    qrBarcode: "QR / Código de Barras",
    analyticsType: "Analítica",
    reports: "Reportes",
    reportsPerMonth: "Reportes/mes",
    tooltipDisabled: "Límite alcanzado. Actualiza tu plan.",
    currentPlan: "Plan Actual",
    planDescription: "Tu suscripción activa y asignación de recursos.",
  },
  footer: {
    tagline: "El WMS inteligente para gestión de inventario.",
    product: "Producto",
    resources: "Legal",
    links: {
      features: "Funcionalidades",
      pricing: "Precios",
      privacy: "Política de Privacidad",
    },
    copyright: "© 2025 Nexo-Warehouse. Todos los derechos reservados.",
  },
  docs: {
    title: "Documentación",
    sidebarTitle: "Guías",
    backHome: "Volver al inicio",
    groups: {
      modules: "Módulos",
      inventory: "Inventario",
      settings: "Configuración",
    },
    sections: {
      warehouses: {
        title: "Bodegas",
        intro: "Una bodega es el espacio físico donde almacenas tu inventario. Es el primer nivel de organización en Nexo Warehouse — todo lo demás (secciones, ubicaciones, inventario) vive dentro de una bodega.",
        blocks: [
          { type: "heading", text: "Antes de empezar" },
          { type: "paragraph", text: "Para crear una bodega necesitas tener al menos un Tipo de Uso registrado en el sistema (ej: Perecederos, Productos terminados). Si no tienes ninguno, ve primero a Configuración → Tipos de Uso y crea uno." },
          { type: "heading", text: "¿Quién puede gestionar bodegas?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear bodega", "✓", "✓", "—", "—", "—"], ["Editar bodega", "✓", "✓", "—", "—", "—"], ["Activar/Desactivar", "✓", "✓", "—", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "Crear una bodega" },
          { type: "steps", items: ["Ve al módulo Bodegas", "Haz clic en + Agregar Bodega", "Completa la información: Nombre (obligatorio), Código (obligatorio, único — no se puede cambiar después), Tipo de uso (obligatorio — se selecciona de los tipos previamente creados), Descripción (opcional)", "Confirma y la bodega queda creada"] },
          { type: "note", text: "Si ya existe una bodega con el mismo código, el sistema te avisará y no permitirá crearla." },
          { type: "heading", text: "Editar una bodega" },
          { type: "paragraph", text: "Puedes modificar el nombre, la descripción y el tipo de uso. El código no se puede cambiar una vez creado." },
          { type: "steps", items: ["Selecciona la bodega", "Haz clic en Editar Bodega", "Modifica los campos que necesites", "Guarda los cambios"] },
          { type: "heading", text: "Activar o desactivar una bodega" },
          { type: "paragraph", text: "Puedes desactivar una bodega para que no reciba inventario ni movimientos. Esto es útil si una bodega deja de operar temporalmente." },
          { type: "note", text: "No puedes desactivar una bodega que aún tiene inventario. Primero debes trasladar o dar salida a todo el inventario." },
          { type: "paragraph", text: "Para reactivarla, simplemente haz clic en Activar." },
          { type: "heading", text: "Cosas a tener en cuenta" },
          { type: "list", items: ["Una bodega necesita al menos una ubicación antes de poder recibir inventario", "El código de cada bodega es único en todo el sistema", "Una bodega inactiva no puede recibir movimientos de inventario"] },
        ],
      },
      locations: {
        title: "Ubicaciones",
        intro: "Las ubicaciones son los puntos exactos dentro de tu bodega donde se almacena el inventario. Se organizan dentro de secciones (islas), que pueden ser de tipo Rack (estantería con niveles y columnas) o Piso/Isla (zonas abiertas con capacidad). Cada ubicación tiene un código único dentro de la bodega.",
        blocks: [
          { type: "heading", text: "¿Cómo se organiza una bodega?" },
          { type: "paragraph", text: "La jerarquía es: Bodega → Sección (Isla) → Ubicación. Una sección puede ser un Rack (organizada, con niveles y columnas que generan posiciones individuales) o un Piso/Isla (no organizada, zona abierta con capacidad total)." },
          { type: "heading", text: "¿Quién puede gestionar ubicaciones?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear sección/ubicación", "✓", "✓", "—", "—", "—"], ["Desactivar ubicación", "✓", "✓", "—", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "Crear una sección (isla)" },
          { type: "steps", items: ["Entra a una bodega", "Haz clic en + Agregar Sección", "Elige el tipo de estructura:", "— Rack: Define nombre, número de niveles y columnas. El sistema genera automáticamente las ubicaciones individuales (ej: 5 niveles × 4 columnas = 20 posiciones)", "— Piso/Isla: Define nombre y capacidad total (opcional). Funciona como una zona de almacenamiento abierta", "Confirma"] },
          { type: "paragraph", text: "Los códigos de ubicación se generan automáticamente según la estructura de la bodega y la sección. No necesitas ingresarlos manualmente." },
          { type: "note", text: "La bodega debe estar activa para crear secciones. Si la bodega está inactiva, no podrás agregar nuevas secciones." },
          { type: "heading", text: "Desactivar una ubicación" },
          { type: "paragraph", text: "Puedes desactivar una ubicación para que no reciba más inventario. Esto es útil para mantenimiento o reorganización." },
          { type: "note", text: "No puedes desactivar una ubicación que tiene inventario activo. Primero debes mover todo el inventario a otra ubicación." },
          { type: "paragraph", text: "Para reactivarla, simplemente cambia el estado de vuelta a activa." },
          { type: "heading", text: "Consultar ubicaciones" },
          { type: "paragraph", text: "Desde cualquier bodega puedes ver todas sus secciones con sus ubicaciones, uso de capacidad y estado actual. Para Racks verás la grilla de posiciones. Para Piso/Isla verás el uso de capacidad total." },
          { type: "heading", text: "Cosas a tener en cuenta" },
          { type: "list", items: ["Una bodega necesita al menos una sección con ubicaciones antes de poder recibir inventario", "Una vez que una ubicación se asigna a una bodega, no puede moverse a otra bodega", "Una vez que una ubicación se asigna a una sección, la sección no puede cambiarse", "Las ubicaciones con historial de movimientos preservan su estructura por trazabilidad", "El código de cada ubicación es único dentro de su bodega", "Las ubicaciones inactivas no pueden recibir movimientos de inventario"] },
        ],
      },
      products: {
        title: "Productos",
        intro: "Los productos son la entidad central del sistema. Todo movimiento de inventario depende de ellos. Antes de poder recibir, despachar o transferir inventario, necesitas tener tus productos registrados.",
        blocks: [
          { type: "heading", text: "Antes de empezar" },
          { type: "paragraph", text: "Para crear un producto necesitas tener al menos una Unidad de Medida registrada en el sistema (ej: Unidad, Caja, Kilogramo). Si no tienes ninguna, ve primero a Configuración → Unidades de Medida y crea una." },
          { type: "heading", text: "¿Quién puede gestionar productos?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear producto", "✓", "✓", "✓", "—", "—"], ["Editar producto", "✓", "✓", "✓", "—", "—"], ["Activar/Desactivar", "✓", "✓", "✓", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "Crear un producto" },
          { type: "steps", items: ["Ve al módulo Productos", "Haz clic en + Agregar Producto", "Completa la información: Código (obligatorio, único — no se puede cambiar después), Nombre (obligatorio), Unidad de Medida (obligatorio — se selecciona de las unidades previamente creadas), Descripción (opcional)", "Confirma y el producto queda creado"] },
          { type: "note", text: "Si ya existe un producto con el mismo código, el sistema te avisará y no permitirá crearlo." },
          { type: "heading", text: "Editar un producto" },
          { type: "paragraph", text: "Puedes modificar el nombre y la descripción. El código y la unidad de medida no se pueden cambiar una vez que el producto tiene inventario asociado." },
          { type: "steps", items: ["Busca el producto en la lista", "Haz clic en Editar Producto", "Modifica los campos permitidos", "Guarda los cambios"] },
          { type: "note", text: "Si el producto ya tiene movimientos de inventario, la unidad de medida no puede cambiarse. Esto protege la integridad de tus datos históricos." },
          { type: "heading", text: "Activar o desactivar un producto" },
          { type: "paragraph", text: "Puedes desactivar un producto para que ya no esté disponible en operaciones de inventario. Esto es útil para productos descontinuados." },
          { type: "note", text: "No puedes desactivar un producto que tiene inventario activo. Primero despacha o ajusta todo el stock existente de ese producto." },
          { type: "paragraph", text: "Para reactivarlo, simplemente haz clic en Activar." },
          { type: "heading", text: "Importación masiva" },
          { type: "paragraph", text: "Si necesitas registrar muchos productos a la vez, puedes usar la función de Importar. Prepara un archivo con los datos de tus productos y súbelo desde el módulo de Productos." },
          { type: "heading", text: "Buscar y filtrar" },
          { type: "paragraph", text: "Puedes buscar productos por código o nombre, y filtrar por estado (Todos, Activos, Inactivos)." },
          { type: "heading", text: "Cosas a tener en cuenta" },
          { type: "list", items: ["El código de cada producto es único en toda tu organización", "La unidad de medida define cómo se cuenta el inventario de este producto", "Los productos inactivos no pueden usarse en ninguna operación de inventario (entradas, salidas, transferencias, ajustes)", "Los productos nunca se eliminan — solo se pueden desactivar"] },
        ],
      },
      stock: {
        title: "Stock",
        intro: "La vista de Stock te muestra el inventario disponible en tiempo real en cada ubicación. Responde a la pregunta: ¿cuánto de cada producto puedo usar ahora mismo?",
        blocks: [
          { type: "heading", text: "¿Qué muestra la vista de Stock?" },
          { type: "paragraph", text: "Para cada combinación de producto y ubicación puedes ver: cantidad en mano (inventario físico), cantidad reservada (bloqueada para operaciones pendientes) y cantidad disponible (lo que realmente puedes usar)." },
          { type: "heading", text: "¿Quién puede ver el stock?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Ver stock", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "¿Cómo se actualiza el stock?" },
          { type: "paragraph", text: "El stock se actualiza automáticamente cada vez que se confirma un movimiento (entrada, salida, transferencia o ajuste). No necesitas actualizarlo manualmente." },
          { type: "heading", text: "Cosas a tener en cuenta" },
          { type: "list", items: ["El stock siempre está en tiempo real — refleja los últimos movimientos confirmados", "Cantidad disponible = En mano − Reservada", "El stock nunca puede ser negativo — el sistema rechazará cualquier operación que lo cause", "Puedes filtrar por bodega, producto o ubicación"] },
        ],
      },
      receipts: {
        title: "Entradas",
        intro: "Las entradas registran toda la mercancía que ingresa a tu inventario. Cada entrada se clasifica por un subtipo (compra, devolución de cliente, producción) para trazabilidad completa.",
        blocks: [
          { type: "heading", text: "¿Quién puede gestionar entradas?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear", "✓", "✓", "✓", "—", "—"], ["Editar (borrador)", "✓", "✓", "✓", "—", "—"], ["Confirmar", "✓", "✓", "—", "—", "—"], ["Anular", "✓", "✓", "—", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "Crear una entrada" },
          { type: "steps", items: ["Ve a Inventario → Entradas", "Haz clic en + Nueva Entrada", "Selecciona el subtipo de movimiento y la bodega destino", "Agrega una o más líneas: selecciona producto, ubicación, cantidad y unidad", "Guarda como borrador"] },
          { type: "heading", text: "Confirmar una entrada" },
          { type: "paragraph", text: "Al confirmar, el sistema suma las cantidades al balance de inventario y al stock. El documento se vuelve inmutable." },
          { type: "note", text: "Solo Admin y Supervisor pueden confirmar. El documento debe tener al menos una línea y el período debe estar abierto." },
          { type: "heading", text: "Anular una entrada confirmada" },
          { type: "paragraph", text: "Puedes anular una entrada confirmada si el período sigue abierto. Esto revierte el impacto en el inventario. Se requiere un motivo." },
          { type: "note", text: "Si el período ya fue cerrado, no puedes anular. Usa un ajuste de inventario en su lugar." },
          { type: "heading", text: "Estados del documento" },
          { type: "list", items: ["Borrador — editable, sin impacto en inventario", "Confirmada — inmutable, inventario actualizado", "Anulada — revertida, impacto deshecho"] },
        ],
      },
      dispatches: {
        title: "Salidas",
        intro: "Las salidas registran toda la mercancía que sale de tu inventario. Cada salida se clasifica por subtipo (venta, avería, salida a producción) para trazabilidad.",
        blocks: [
          { type: "heading", text: "¿Quién puede gestionar salidas?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear", "✓", "✓", "✓", "—", "—"], ["Editar (borrador)", "✓", "✓", "✓", "—", "—"], ["Confirmar", "✓", "✓", "—", "—", "—"], ["Anular", "✓", "✓", "—", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "Crear una salida" },
          { type: "steps", items: ["Ve a Inventario → Salidas", "Haz clic en + Nueva Salida", "Selecciona el subtipo de movimiento y la bodega origen", "Agrega líneas: producto, ubicación, cantidad y unidad", "Guarda como borrador"] },
          { type: "heading", text: "Confirmar una salida" },
          { type: "paragraph", text: "Al confirmar, el sistema resta las cantidades del inventario. Si no hay stock suficiente en alguna línea, la confirmación completa se rechaza." },
          { type: "note", text: "El sistema valida stock suficiente al momento de la confirmación, no al guardar el borrador." },
          { type: "heading", text: "Anular una salida confirmada" },
          { type: "paragraph", text: "Anular devuelve el stock. El período debe estar abierto y se requiere un motivo." },
          { type: "heading", text: "Cosas a tener en cuenta" },
          { type: "list", items: ["Ninguna salida puede dejar un saldo de stock negativo", "Todas las líneas se confirman o anulan de forma atómica — nunca parcialmente", "Las salidas anuladas no pueden editarse; crea una nueva en su lugar"] },
        ],
      },
      transfers: {
        title: "Transferencias",
        intro: "Las transferencias mueven mercancía entre dos bodegas de tu organización. Una transferencia crea simultáneamente una salida del origen y una entrada al destino, manteniendo el inventario total sin cambios.",
        blocks: [
          { type: "heading", text: "¿Quién puede gestionar transferencias?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear", "✓", "✓", "✓", "—", "—"], ["Editar (borrador)", "✓", "✓", "✓", "—", "—"], ["Confirmar", "✓", "✓", "—", "—", "—"], ["Anular", "✓", "—", "—", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "Crear una transferencia" },
          { type: "steps", items: ["Ve a Inventario → Transferencias", "Haz clic en + Nueva Transferencia", "Selecciona bodega origen y bodega destino (deben ser diferentes)", "Agrega líneas: producto, ubicación origen, ubicación destino, cantidad, unidad", "Guarda como borrador"] },
          { type: "heading", text: "Confirmar una transferencia" },
          { type: "paragraph", text: "La confirmación ejecuta ambos movimientos de forma atómica: salida del origen y entrada al destino. Si el origen no tiene stock suficiente, toda la transferencia se rechaza." },
          { type: "note", text: "Ambos períodos de bodega deben estar abiertos. Las bodegas origen y destino deben ser diferentes." },
          { type: "heading", text: "Anular una transferencia" },
          { type: "paragraph", text: "Solo Admin puede anular. La reversión requiere que el stock recibido en el destino no haya sido consumido por otras operaciones." },
          { type: "note", text: "Si el stock en el destino ya fue despachado, la anulación se bloquea. Usa un ajuste de inventario para corregir." },
          { type: "heading", text: "Cosas a tener en cuenta" },
          { type: "list", items: ["El inventario total entre todas las bodegas permanece igual después de una transferencia", "Tanto la salida como la entrada ocurren en una sola operación atómica", "Necesitas los subtipos TRANSFER_OUT y TRANSFER_IN configurados (ver Subtipos de Movimiento)"] },
        ],
      },
      adjustments: {
        title: "Ajustes",
        intro: "Los ajustes corrigen diferencias entre el inventario físico y los registros del sistema. A diferencia de las entradas y salidas, los ajustes requieren aprobación de un segundo usuario autorizado antes de impactar el inventario.",
        blocks: [
          { type: "heading", text: "¿Quién puede gestionar ajustes?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear", "✓", "✓", "✓", "—", "—"], ["Editar (borrador)", "✓", "✓", "✓", "—", "—"], ["Enviar a aprobación", "✓", "✓", "✓", "—", "—"], ["Aprobar", "✓", "✓", "—", "—", "—"], ["Rechazar", "✓", "✓", "—", "—", "—"], ["Anular (post aprobación)", "✓", "—", "—", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "El flujo de aprobación" },
          { type: "steps", items: ["Crea el ajuste con líneas (cantidades positivas o negativas)", "Envía a aprobación", "Un usuario diferente (Admin o Supervisor) revisa y aprueba o rechaza", "Solo al aprobar se actualiza el inventario"] },
          { type: "note", text: "El aprobador debe ser un usuario diferente al creador. No puedes aprobar tus propios ajustes." },
          { type: "heading", text: "Líneas positivas y negativas" },
          { type: "paragraph", text: "Cada línea puede ser positiva (agrega inventario — se encontró algo en el conteo) o negativa (quita inventario — algo falta). Ambos tipos pueden coexistir en el mismo ajuste." },
          { type: "heading", text: "Rechazo y corrección" },
          { type: "paragraph", text: "Si un ajuste es rechazado, vuelve a estado borrador. El creador puede editarlo y reenviarlo. El motivo del rechazo queda visible en el historial del documento." },
          { type: "heading", text: "Estados del documento" },
          { type: "list", items: ["Borrador — editable, sin impacto", "En Aprobación — en revisión, no editable", "Aprobado — inventario actualizado, inmutable", "Rechazado — vuelve a editable para corrección", "Anulado — ajuste aprobado revertido (solo Admin)"] },
        ],
      },
      balance: {
        title: "Balance de Inventario",
        intro: "El Balance muestra una vista consolidada del inventario por período mensual. Registra saldo inicial, entradas, salidas y saldo actual para cada producto y ubicación.",
        blocks: [
          { type: "heading", text: "¿Quién puede gestionar el balance?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Ver balance actual", "✓", "✓", "✓", "✓", "✓"], ["Ver historial", "✓", "✓", "—", "—", "—"], ["Cerrar período", "✓", "✓", "—", "—", "—"]] },
          { type: "heading", text: "¿Cómo funciona?" },
          { type: "paragraph", text: "Cada movimiento confirmado (entrada, salida, transferencia, ajuste) actualiza automáticamente el balance del período actual. No necesitas hacer nada manualmente — solo consúltalo." },
          { type: "heading", text: "Cierre de período" },
          { type: "paragraph", text: "Al final de cada mes, un Admin o Supervisor cierra el período. Esto bloquea el balance y crea el siguiente período con el saldo de cierre como nuevo saldo inicial." },
          { type: "note", text: "No puedes cerrar un período si hay movimientos pendientes (borradores o ajustes en aprobación). Resuélvelos primero." },
          { type: "heading", text: "Filtros" },
          { type: "paragraph", text: "Puedes filtrar el balance por año, mes y bodega para ver exactamente lo que necesitas." },
          { type: "heading", text: "Cosas a tener en cuenta" },
          { type: "list", items: ["Saldo actual = Saldo inicial + Entradas − Salidas", "Una vez cerrado un período, no se pueden registrar más movimientos en él", "Si necesitas corregir un período cerrado, crea un ajuste en el período abierto actual", "El balance opera a nivel de ubicación — los totales de bodega son la suma de todas las ubicaciones"] },
        ],
      },
      kardex: {
        title: "Kardex",
        intro: "El Kardex es un registro inmutable de cada transacción de inventario. Es la fuente de verdad — cada entrada, salida, transferencia y ajuste genera registros aquí que nunca pueden modificarse ni eliminarse.",
        blocks: [
          { type: "heading", text: "¿Quién puede ver el kardex?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Kardex completo", "✓", "✓", "—", "—", "—"], ["Por documento", "✓", "✓", "✓", "—", "—"]] },
          { type: "heading", text: "¿Qué muestra?" },
          { type: "paragraph", text: "Para cada movimiento: fecha, producto, tipo (entrada/salida), subtipo, cantidad, saldo resultante, documento origen y referencia." },
          { type: "heading", text: "Filtros" },
          { type: "paragraph", text: "Puedes filtrar por bodega, rango de fechas y producto para acotar el historial que necesitas." },
          { type: "heading", text: "¿Por qué es importante?" },
          { type: "list", items: ["Permite reconstruir cualquier saldo histórico en cualquier momento", "Proporciona trazabilidad completa de cada unidad que entró o salió de tu inventario", "Soporta requerimientos de auditoría y cumplimiento legal", "No puede alterarse — una vez registrado, los movimientos son permanentes"] },
        ],
      },
      typeUse: {
        title: "Tipos de Uso",
        intro: "Los Tipos de Uso definen la categoría o propósito de una bodega (ej: Perecederos, Productos terminados, Materia prima). Necesitas al menos un tipo de uso antes de poder crear una bodega.",
        blocks: [
          { type: "heading", text: "¿Quién puede gestionar tipos de uso?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear", "✓", "✓", "—", "—", "—"], ["Editar", "✓", "✓", "—", "—", "—"], ["Eliminar", "✓", "✓", "—", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "Crear un tipo de uso" },
          { type: "steps", items: ["Ve a Configuración → Tipos de Uso", "Haz clic en + Agregar Tipo de Uso", "Ingresa un nombre (mínimo 3 caracteres)", "Confirma"] },
          { type: "note", text: "Si ya existe un tipo de uso con el mismo nombre, el sistema no permitirá crearlo." },
          { type: "heading", text: "Editar o eliminar" },
          { type: "paragraph", text: "Puedes editar el nombre o eliminar un tipo de uso. La eliminación solo es posible si ninguna bodega está usando ese tipo actualmente." },
        ],
      },
      typeUnit: {
        title: "Unidades de Medida",
        intro: "Las Unidades de Medida definen cómo se cuenta el inventario de cada producto (ej: Unidad, Caja, Kilogramo, Litro). Necesitas al menos una unidad antes de poder crear productos.",
        blocks: [
          { type: "heading", text: "¿Quién puede gestionar unidades?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear", "✓", "✓", "—", "—", "—"], ["Activar/Desactivar", "✓", "✓", "—", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "Crear una unidad" },
          { type: "steps", items: ["Ve a Configuración → Unidades de Medida", "Haz clic en + Crear Unidad", "Completa: Código (único, ej: UD, CJ, KG), Nombre (ej: Unidad, Caja, Kilogramo), Abreviatura (ej: ud, caja, kg)", "Confirma"] },
          { type: "note", text: "El código y la abreviatura deben ser únicos. Si ya existen, el sistema te lo indicará." },
          { type: "heading", text: "Activar o desactivar" },
          { type: "paragraph", text: "Puedes desactivar una unidad que ya no necesites. Las unidades inactivas no pueden asignarse a nuevos productos pero siguen visibles en los registros existentes." },
          { type: "heading", text: "Buscar y filtrar" },
          { type: "paragraph", text: "Puedes buscar unidades por código o nombre, y filtrar por estado (Todas, Activas, Inactivas)." },
        ],
      },
      movementSubtypes: {
        title: "Subtipos de Movimiento",
        intro: "Los Subtipos de Movimiento definen la razón operativa detrás de cada transacción de inventario. Clasifican los movimientos en lenguaje de negocio (ej: Compra, Venta, Avería, Devolución de cliente) mientras el sistema maneja la matemática automáticamente.",
        blocks: [
          { type: "heading", text: "¿Cómo funcionan los subtipos?" },
          { type: "paragraph", text: "Cada subtipo está vinculado a un tipo de movimiento: Entrada (suma inventario) o Salida (resta inventario). Cuando creas una entrada, salida o ajuste, seleccionas un subtipo que clasifica por qué se está haciendo el movimiento." },
          { type: "heading", text: "¿Quién puede gestionar subtipos?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear", "✓", "✓", "—", "—", "—"], ["Editar", "✓", "✓", "—", "—", "—"], ["Activar/Desactivar", "✓", "✓", "—", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "Crear un subtipo" },
          { type: "steps", items: ["Ve a Configuración → Subtipos de Movimiento", "Haz clic en + Crear Subtipo", "Selecciona el tipo de movimiento (Entrada o Salida)", "Completa: Código (único, ej: COMPRA, VENTA, AVERIA), Nombre, si requiere documento de referencia", "Confirma"] },
          { type: "heading", text: "Documentos de referencia" },
          { type: "paragraph", text: "Algunos subtipos pueden requerir un documento de referencia (como un número de factura u orden de compra). Si se activa esta opción, los usuarios deberán proporcionar esta referencia al crear un movimiento con ese subtipo." },
          { type: "heading", text: "Subtipos para transferencias" },
          { type: "note", text: "Si planeas usar transferencias entre bodegas, necesitas crear dos subtipos: TRANSFER_OUT (tipo: Salida) y TRANSFER_IN (tipo: Entrada), ambos sin requerir documento de referencia. El sistema los usa automáticamente al procesar transferencias." },
          { type: "heading", text: "Cosas a tener en cuenta" },
          { type: "list", items: ["El código de cada subtipo es único dentro de tu organización", "El tipo de movimiento (Entrada/Salida) no puede cambiarse después de creado", "Los subtipos inactivos no pueden usarse en nuevos movimientos pero permanecen visibles en registros históricos", "Puedes editar el nombre y el requerimiento de referencia, pero no el código ni el tipo"] },
        ],
      },
      unitConversions: {
        title: "Conversiones de Unidad",
        intro: "Las Conversiones de Unidad definen la equivalencia entre diferentes unidades de medida para un producto específico. Por ejemplo: 1 Caja = 12 Unidades, o 1 Estiba = 24 Cajas. Esto permite registrar movimientos de inventario en cualquier nivel de empaque.",
        blocks: [
          { type: "heading", text: "¿Quién puede gestionar conversiones?" },
          { type: "table", headers: ["Acción", "Admin", "Supervisor", "Auxiliar", "Operario", "Viewer"], rows: [["Crear", "✓", "✓", "—", "—", "—"], ["Editar", "✓", "✓", "—", "—", "—"], ["Activar/Desactivar", "✓", "✓", "—", "—", "—"], ["Consultar", "✓", "✓", "✓", "✓", "✓"]] },
          { type: "heading", text: "Crear una conversión" },
          { type: "steps", items: ["Ve a Configuración → Conversiones", "Haz clic en + Crear Conversión", "Selecciona: Unidad base (ej: Unidad), Unidad de embalaje (ej: Caja), Producto, Factor de conversión (ej: 12 significa 1 Caja = 12 Unidades)", "Confirma"] },
          { type: "note", text: "No puedes crear una conversión donde la unidad base y la unidad de embalaje sean la misma. El factor debe ser un número positivo mayor que cero." },
          { type: "heading", text: "Editar una conversión" },
          { type: "paragraph", text: "Puedes modificar el factor de conversión. Los cambios solo aplican a movimientos futuros — los movimientos históricos existentes conservan el factor que estaba vigente en su momento." },
          { type: "heading", text: "Activar o desactivar" },
          { type: "paragraph", text: "Desactivar una conversión evita que se use en nuevos movimientos. Los movimientos existentes no se ven afectados." },
          { type: "note", text: "Solo puede existir una conversión activa para el mismo par de unidades por producto. Si necesitas cambiar el par, desactiva la actual y crea una nueva." },
          { type: "heading", text: "Cosas a tener en cuenta" },
          { type: "list", items: ["Cada conversión está vinculada a un producto específico", "El factor de conversión define cuántas unidades base componen una unidad de embalaje", "Los cambios en el factor no afectan movimientos pasados — solo aplican hacia adelante", "El sistema calcula automáticamente las equivalencias cuando registras movimientos en unidades diferentes"] },
        ],
      },
    },
  },
};
